import type { PopupMenuProps } from './PopupMenu'
import PopupMenu from './PopupMenu'

export type { PopupMenuProps }
export default PopupMenu
